'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var utils = require('@chakra-ui/utils');

// COPY BEGIN
// This part is copied from
// https://github.com/chakra-ui/chakra-ui/blob/b958893bd458ee7ffbaf725a4185636f48b19590/packages/system/src/hooks.ts#L40
// for `getToken`. Use `import { getToken } from '@chakra-ui/system'` after upgrading to Chakra UI 2.0+.
function getBreakpointValue(theme, value, fallback) {
  var _ref, _getValue;
  if (value == null) return value;
  var getValue = function getValue(val) {
    var _theme$__breakpoints, _theme$__breakpoints$;
    return (_theme$__breakpoints = theme.__breakpoints) === null || _theme$__breakpoints === void 0 ? void 0 : (_theme$__breakpoints$ = _theme$__breakpoints.asArray) === null || _theme$__breakpoints$ === void 0 ? void 0 : _theme$__breakpoints$[val];
  };
  return (_ref = (_getValue = getValue(value)) !== null && _getValue !== void 0 ? _getValue : getValue(fallback)) !== null && _ref !== void 0 ? _ref : fallback;
}
function getTokenValue(theme, value, fallback) {
  var _ref2, _getValue2;
  if (value == null) return value;
  var getValue = function getValue(val) {
    var _theme$__cssMap, _theme$__cssMap$val;
    return (_theme$__cssMap = theme.__cssMap) === null || _theme$__cssMap === void 0 ? void 0 : (_theme$__cssMap$val = _theme$__cssMap[val]) === null || _theme$__cssMap$val === void 0 ? void 0 : _theme$__cssMap$val.value;
  };
  return (_ref2 = (_getValue2 = getValue(value)) !== null && _getValue2 !== void 0 ? _getValue2 : getValue(fallback)) !== null && _ref2 !== void 0 ? _ref2 : fallback;
}
function getToken(scale, token, fallback) {
  var _token = Array.isArray(token) ? token : [token];
  var _fallback = Array.isArray(fallback) ? fallback : [fallback];
  return function (theme) {
    var fallbackArr = _fallback.filter(Boolean);
    var result = _token.map(function (innerToken, index) {
      var _fallbackArr$index2;
      if (scale === 'breakpoints') {
        var _fallbackArr$index;
        return getBreakpointValue(theme, innerToken, (_fallbackArr$index = fallbackArr[index]) !== null && _fallbackArr$index !== void 0 ? _fallbackArr$index : innerToken);
      }
      var path = "".concat(scale, ".").concat(innerToken);
      return getTokenValue(theme, path, (_fallbackArr$index2 = fallbackArr[index]) !== null && _fallbackArr$index2 !== void 0 ? _fallbackArr$index2 : innerToken);
    });
    return Array.isArray(token) ? result : result[0];
  };
}
// This part is copied from
// https://github.com/chakra-ui/chakra-ui/blob/b958893bd458ee7ffbaf725a4185636f48b19590/packages/system/src/hooks.ts#L40
// for `getToken`. Use `import { getToken } from '@chakra-ui/system'` after upgrading to Chakra UI 2.0+.
// COPY END.

// This part is taken from `SimpleGrid` @ https://github.com/chakra-ui/chakra-ui/blob/b958893bd458ee7ffbaf725a4185636f48b19590/packages/layout/src/simple-grid.tsx#L76-L91
function toPx(n) {
  return utils.isNumber(n) ? "".concat(n, "px") : n;
}
function widthToColumns(width, theme) {
  return utils.mapResponsive(width, function (value) {
    var _value = getToken('sizes', value, toPx(value))(theme);
    return utils.isNull(value) ? null : "repeat(auto-fit, minmax(".concat(_value, ", 1fr))");
  });
}
function countToColumns(count) {
  return utils.mapResponsive(count, function (value) {
    return utils.isNull(value) ? null : "repeat(".concat(value, ", minmax(0, 1fr))");
  });
}
exports.countToColumns = countToColumns;
exports.getToken = getToken;
exports.widthToColumns = widthToColumns;